import { get, post } from "../utils/request";
import CryptData from "../utils/cryptData";

/**
 * 获取商品列表
 * @param {*} vm
 * @param {*} cb
 */
export const getShopList = (vm, cb) => {
  let params = {
    pageNo: vm.current,
    pageSize: vm.display,
    name: vm.keyword
  };
  // 0 => vip  1=> 非vip
  if (vm.activeTab == 4) {
    params.vip = 0;
  } else if (vm.activeTab == 5) {
    params.vip = 2;
  } else {
    params.vip = 1;
    params.type = vm.activeTab;
  }
  vm.listData = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/goods/findGoogdsListByType", params)
    .then(res => {
      //console.log(res);
      vm.isloading = false;
      if (res.code == 200 && res.data) {
        vm.listData = res.data.list.map(item => {
          item.price =
            item.goodsInformations.length > 0
              ? item.goodsInformations[0].price
              : "";
          // item.imgsUrl = item.imgsUrl ? vm.comImgUrl + item.imgsUrl : "";
          item.imgsUrl = item.imgsUrl
            ? vm.comImgUrl + item.imgsUrl.split("|")[0]
            : "";
          return item;
        });
        vm.total = res.data.total;
      }
      vm.nodata = vm.listData.length == 0 ? true : false;
      vm.$tips_msg(vm, res);
      cb && cb();
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.listData.length == 0 ? true : false;
      vm.$tips_error(vm, error);
      //console.log(error);
    });
};

/**
 * 获取商品详情
 * @param {*} vm
 * @param {*} cb
 */
export const getShopDetail = (vm, cb) => {
  let params = {
    id: vm.detailId
  };
  post("/api/goods/goodsInformationById", params)
    .then(res => {
      console.log(res);
      if (res.code === 200 && res.data) {
        vm.imglist = res.data.imgsUrl.split("|") || [];
        vm.imglist = vm.imglist.map(item => {
          item = vm.comImgUrl + item;
          return item;
        });
        vm.imgView = vm.imglist.length > 0 ? vm.imglist[0] : "";
        vm.title = res.data.name;
        vm.shopDetailContent = res.data.details;
        vm.monthSales = res.data.monthSales || 0;
        /**
         * res.data.type
         * 0 饲料商品 => 显示系列，颗粒，包装
         *
         * 1 器材商品 \3 其他商品 ' => 显示规格
         *
         * 2 活体商品 => 不显示筛选条件
         *
         */
        vm.type = res.data.type;
        vm.createFilter(res.data.goodsInformations, res.data.type);
      }
      vm.$tips_msg(vm, res);
      cb && cb(res);
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取商品筛选规格
 * @param {*} vm
 * @param {*} cb
 */
export const getShopFilter = (vm, cb) => {
  post("/api/auction/goodsInfoList", vm.filterParams)
    .then(res => {
      cb && cb(res);
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 添加购物车
 * @param {*} vm
 * @param {*} cb
 */
export const addShopCart = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    goodsId: vm.detailId,
    unitPrice: vm.price,
    number: vm.count
  };
  if (vm.type === 0) {
    params.series = vm.selectValue.series;
    params.particles = vm.selectValue.particles;
    params.pack = vm.selectValue.pack;
    params.specification = "";
  }
  if (vm.type === 1 || vm.type === 3) {
    params.specification = vm.selectValue.specification;
  }
  post("/api/shoppingCart/addShoppingCart", params)
    .then(res => {
      //console.log(res);
      cb && cb(res);
      // vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取购物车列表
 * @param {*} vm
 * @param {*} cb
 */
export const getCartList = (vm, cb, type) => {
  let params = {
    userId: vm.userInfo.userId,
    pageNo: vm.current,
    pageSize: vm.display
  };
  if (!type) {
    vm.cartData = [];
    vm.isloading = true;
    vm.nodata = false;
  }

  post("/api/shoppingCart/shoppingCartList", params)
    .then(res => {
      vm.isloading = false;
      //console.log(res);
      if (res.code === 200) {
        vm.cartData = res.data.list.map(item => {
          let goods = item.goods ? item.goods : {};
          item.goods = item.goods ? item.goods : {};
          item.image = goods.imgsUrl
            ? vm.comImgUrl + goods.imgsUrl.split("|")[0]
            : "";
          item.details = goods.details ? goods.details : "";
          item.price = item.unitPrice;
          item.total = item.number;
          return item;
        });
        vm.totalsize = res.data.total;
      }
      vm.nodata = vm.cartData.length > 0 ? false : true;
      vm.$tips_msg(vm, res);
      cb && cb();
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.cartData.length > 0 ? false : true;
      vm.$tips_error(vm, error);
    });
};

/**
 * 删除购物车列表数据
 * @param {*} vm
 * @param {*} param
 * @param {*} cb
 */
export const delCart = (vm, param, cb) => {
  let data = {},
    url = "";
  if (param instanceof Array) {
    data = {
      ids: param
    };
    url = "/api/shoppingCart/deleteByIds";
  } else {
    data = {
      id: param
    };
    url = "/api/shoppingCart/deleteById";
  }
  post(url, data)
    .then(res => {
      //console.log(res);
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取用户收获地址
 * @param {*} vm
 * @param {*} cb
 */
export const getUserAddressList = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId
  };
  post("/api/logisticsAddress/selectByUserId", params)
    .then(res => {
      //console.log(res);
      if (res.code == 200) {
        let hasDefault = false,
          defaultItem = {},
          defalutIndex = 0;
        vm.orderAddressList = res.data.map((item, index) => {
          if (item.isDefault === 0) {
            hasDefault = true;
            defaultItem = item;
            defalutIndex = index;
          }
          return item;
        });
        if (hasDefault) {
          vm.orderAddressSelect = defaultItem.id;
          vm.orderAddressText =
            defaultItem.consignee +
            " " +
            defaultItem.contactPhone +
            " " +
            defaultItem.shippingAddress;
          vm.orderAddressList.splice(defalutIndex, 1);
          vm.orderAddressList.unshift(defaultItem);
        } else {
          let _fitem =
            vm.orderAddressList.length > 0 ? vm.orderAddressList[0] : {};
          vm.orderAddressSelect =
            vm.orderAddressList.length > 0 ? _fitem.id : "";
          vm.orderAddressText =
            vm.orderAddressList.length > 0
              ? _fitem.consignee +
                " " +
                _fitem.contactPhone +
                " " +
                _fitem.shippingAddress
              : "";
        }
      } else {
        vm.$notify({
          title: "提示",
          message: "获取用户收货地址失败: " + JSON.stringify(res),
          type: "error"
        });
      }
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 添加||修改收货地址
 * @param {1} vm
 * @param {*} cb
 */
export const add_updata_Address = (vm, cb) => {
  let params = {
      userId: vm.userInfo.userId,
      consignee: vm.form.consignee.value,
      contactPhone: vm.form.contactPhone.value,
      shippingAddress: vm.form.shippingAddress.value,
      zipCode: vm.form.zipCode.value,
      isDefault: vm.checkVal ? 0 : 1
    },
    url = "";
  if (vm.id) {
    url = "/api/logisticsAddress/update";
    params.id = vm.id;
  } else {
    url = "/api/auction/logisticsAddress";
  }
  post(url, params)
    .then(res => {
      cb && cb(res);
    })
    .catch(error => {
      vm.isLoading = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 删除收货地址
 * @param {*} vm
 * @param {*} param
 * @param {*} cb
 */
export const delAddress = (vm, param, cb) => {
  post("/api/logisticsAddress/delete", param)
    .then(res => {
      //console.log(res);
      cb && cb(res);
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 首页推荐商品
 * @param {*} vm
 * @param {*} cb
 */
export const recommendProduct = (vm, cb) => {
  post("/api/goods/recommend")
    .then(res => {
      //console.log(res);
      if (res.code === 200) {
        let list = res.data || [];
        vm.commodity = list.map(item => {
          item.imgsUrl = item.imgsUrl
            ? vm.comImgUrl + item.imgsUrl.split("|")[0]
            : "";
          return item;
        });
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};
